'use strict';

import React from 'react';

class Header extends React.Component<React.PropsWithChildren> {
  render() {
    return (
      <div className="text-center md:text-left flex flex-col md:flex-row justify-between items-center mb-3 md:mb-5">
        {this.props.children}
      </div>
    );
  }
}

export default Header;
